// CMS entries for dfsweb-rewamp-schemes override these at runtime.
export const en = {
  "SCHEME_INFO.DOCUMENT_CONTENT_EMPTY":
    "There is currently no content available for this section. You may check back later for updates.",
  "SCHEME_INFO.GUIDELINES_LABEL": "Guidelines",
  "SCHEME_INFO.APPLY_NOW_CTA": "Apply",
  "SCHEME_INFO.ABOUT_LABEL": "About this Scheme",
  "SCHEME_INFO.TAB_BENEFITS": "Scheme Benefits",
  // TAB_ELIGIBILITY/TAB_DOCUMENTS never existed in the legacy bundle — copy is inferred, needs a translator.
  "SCHEME_INFO.TAB_ELIGIBILITY": "Eligibility Criteria",
  "SCHEME_INFO.TAB_DOCUMENTS": "Document Requirements",
};

export const hi = {
  "SCHEME_INFO.DOCUMENT_CONTENT_EMPTY":
    "इस अनुभाग के लिए वर्तमान में कोई सामग्री उपलब्ध नहीं है। आप अपडेट के लिए बाद में पुनः जांच सकते हैं।",
  "SCHEME_INFO.GUIDELINES_LABEL": "दिशानिर्देश",
  "SCHEME_INFO.APPLY_NOW_CTA": "आवेदन करें",
  "SCHEME_INFO.ABOUT_LABEL": "योजना के बारे में जानकारी",
  "SCHEME_INFO.TAB_BENEFITS": "योजना के लाभ",
  // Inferred — see en.
  "SCHEME_INFO.TAB_ELIGIBILITY": "पात्रता मानदंड",
  "SCHEME_INFO.TAB_DOCUMENTS": "दस्तावेज़ आवश्यकताएँ",
};
